namespace TabAurous.Administration {
    export interface SequenceRow {
        Id?: number;
        Code?: string;
        Name?: string;
        Processes?: SequenceDetailsRow[];
    }

    export namespace SequenceRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.Sequence';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Code = "Code",
            Name = "Name",
            Processes = "Processes"
        }
    }
}
